var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMarker = function SvgIconMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconMarker",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.17323 17.00787"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M7.08661,8.20855c1.02136,0,1.84933-.82797,1.84933-1.84933s-.82797-1.84933-1.84933-1.84933-1.84933.82797-1.84933,1.84933.82797,1.84933,1.84933,1.84933Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M7.08659,2.68951c2.04468,0,3.70215,1.6575,3.70215,3.70215,0,3.47574-3.70215,6.94083-3.70215,6.94083,0,0-3.70209-3.46509-3.70209-6.94083,0-2.04465,1.65747-3.70215,3.70209-3.70215M7.08659.02951C3.57853.02951.72453,2.88357.72453,6.39166c0,4.49951,4.07922,8.44751,4.54437,8.88287h3.63538c.46515-.43536,4.54443-4.38336,4.54443-8.88287C13.44871,2.88357,10.59471.02951,7.08659.02951h0Z"
  })));
};
export default SvgIconMarker;